/**
 * assignContacts.js
 * import axios for server calls
 */
import React, { useState } from "react";
import axios from "axios";
/**
 * @param contact = contact ID
 * @param eventID = event ID
 * @param getEventContacts = function call back to retrive event contacts
 */
function AssignContact({ contact, eventID, getEventContacts}) {
  const contactId = contact._id;
  const isAttending = contact.eventID.includes(eventID);
  const [isChecked, setIsChecked] = useState(isAttending);

/**
 * function deleteAttend()
 * deletes a contact from an event, then gets new event contacts
 */
  async function deleteAttend() {
    console.log('delete attend')
    await axios.put(
      `https://link2rsvp.herokuapp.com/contact/${contactId}/event/delete/${eventID}`
    );
    getEventContacts();
  }
/**
 * function addAttend()
 * adds a contact to an event, then gets new event contacts
 */
  async function addAttend() {
    await axios.put(
      `https://link2rsvp.herokuapp.com/contact/${contactId}/event/add/${eventID}`
    );
    getEventContacts();
  }

  const toggleCheckStatus = () => {
    if (isChecked) {
      setIsChecked(false);
      deleteAttend();
    } else {
      setIsChecked(true);
      addAttend();
    }
  };


  return (
    <div style={{ height: 40 }}>
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          checked={isChecked}
          onChange={() => toggleCheckStatus()}
          id="attend"
        />
        <label className="form-check-label" htmlFor="attend">
          {contact.name}
        </label>
      </div>
    </div>
  );
}

export default AssignContact;
